import App from './App';
import React from 'react';
import ReactDOM from 'react-dom/client';
import ContextBootstrap from './contexts/bootstrap/ContextBootstrap';
import ContextBuffer from './contexts/bootstrap/ContextBuffer';
import RoutingContext from './contexts/routing/RoutingContext';
import { AppQueryProvider } from './shared/react-query';
import { setNonce } from "@danfoss/mosaic-core/loader";
import { ErrorHandler } from './contexts/error-handler/ErrorHandler';

// Mosaic (and styles)
import '@danfoss/mosaic-css/dist/mosaic.css';
import './index.scss';
import 'material-icons/iconfont/material-icons.css';
import { ThemeProvider } from './contexts/theme/ThemeContext';


// Initialize nonces at app startup
const { initializeNonces, getMosaicNonce } = require('./constants/nonce');
const nonces = initializeNonces();
const mosaic = nonces.mosaic;
const cookie = nonces.cookie;

// Store nonces globally for access throughout the app
(window as any).__APP_NONCES__ = { mosaic, cookie };

if (process.env.NODE_ENV !== 'development') {
    // Inject nonce values to CSP policy (append if directives already exist)
    const existingCSP = document.querySelector('meta[http-equiv="Content-Security-Policy"]');
    if (existingCSP) {
        // Parse and update existing CSP
        let currentContent = existingCSP.getAttribute('content') || '';

        // Update script-src directive
        if (currentContent.includes('script-src')) {
            currentContent = currentContent.replace(/script-src([^;]*)/g, `script-src$1 'nonce-${cookie}'`);
        } else {
            currentContent += `; script-src 'nonce-${cookie}'`;
        }

        // // Update style-src directive
        // if (currentContent.includes('style-src')) {
        //     currentContent = currentContent.replace(/style-src([^;]*)/g, `style-src$1 'nonce-${cookie}'`);
        // } else {
        //     currentContent += `; style-src 'nonce-${cookie}'`;
        // }

        existingCSP.setAttribute('content', currentContent);
    } else {
        // Create new CSP meta tag if none exists
        const cspMetaTag = document.createElement('meta');
        cspMetaTag.httpEquiv = 'Content-Security-Policy';
        cspMetaTag.content = `script-src '${cookie}'; style-src '${cookie}'`;
        document.head.appendChild(cspMetaTag);
    }
}
// Set nonce for Mosaic library
setNonce(mosaic);

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

try {
    root.render(
        <RoutingContext>
            <ErrorHandler>
                <ThemeProvider>
                    <AppQueryProvider>
                        <ContextBootstrap>
                            <ContextBuffer>
                                <App />
                            </ContextBuffer>
                        </ContextBootstrap>
                    </AppQueryProvider>
                </ThemeProvider>
            </ErrorHandler>
        </RoutingContext>
    );
} catch (error) {
    console.error('Render error:', error);
}
